module.exports = __webpack_public_path__ + "static/media/72.95df01e4.jpg";